import { render, staticRenderFns } from "./SupportServerLink.vue?vue&type=template&id=24dd49f6&"
import script from "./SupportServerLink.vue?vue&type=script&lang=js&"
export * from "./SupportServerLink.vue?vue&type=script&lang=js&"
import style0 from "./SupportServerLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports